<app-lfsa-card [innTemplate]="requisicion" [titulo]="titulo" [efecto]="true" [colapseName]="'requisicion'"
  [banderaColapse]='true'></app-lfsa-card>
<ng-template #requisicion>
  <form [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div [class]="'col-md-3'">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idDistribuidor'"
          [comboBox]="cmbDistribuidor" formControlName="idDistribuidor" [control]="formulario.get('idDistribuidor')"
          [label]="'Distribuidor*'" [id]="'idDistribuidor'">
        </app-lfsa-combo-box>
      </div>
      <div [class]="'col-md-3'">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('anio')"
          [placeholder]="'Año'" formControlName="anio" [label]="'Año*'" [type]="'number'" [id]="'anio'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-3'">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'id'" [comboBox]="cmbMes"
          formControlName="mes" [control]="formulario.get('mes')" [label]="'Mes*'" [id]="'mes'">
        </app-lfsa-combo-box>
      </div>
      <div [class]="'col-md-3'">
        <label>&nbsp;</label>
        <button [disabled]="this.formulario.invalid" (click)="getData()"
          class="btn btn-success btn-block">Buscar</button>
      </div>
    </div>
  </form>
  <br>
</ng-template>


<app-lfsa-card *ngIf="mostrarCard" [innTemplate]="datosRequisicion" [titulo]="subTitulo" [efecto]="true"
  [colapseName]="'datosRequisicion'" [banderaColapse]='true'></app-lfsa-card>

<ng-template #datosRequisicion>
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <h5>Cliente Distribucion: {{ reporteModel.codigoCliente }} </h5>
      </div>
      <!-- <div class="col-md-6">
        <h5>Presupuesto Venta Semanal: $ {{ reporteModel.presupuestoVentaSemanal }} </h5>
      </div> -->
    </div>
    <div class="row">
      <div class="col-md-6">
        <h5>Año: {{ reporteModel.anio }} </h5>
      </div>
      <!-- <div class="col-md-6">
        <h5>Presupuesto Efectividad Mensual: {{ reporteModel.efectividadMensual }} % </h5>
      </div> -->
    </div>
    <!-- <div class="row">
      <div class="col-md-6">
        <h5>Número Semana: {{ reporteModel.numeroSemana }} </h5>
      </div>
    </div> -->
  </div>
  <br>
  <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
  <div *ngIf="!loading">
    <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
      No existen datos para la lista de Documentos.
    </div>
    <ag-grid-angular [floatingFilter]="true" *ngIf="!listaVacia" #agGrid
      class=" {{distribuidorModulo.agGridConsulta.class}}" #agGridConsulta
      [ngStyle]="distribuidorModulo.agGridConsulta.style" id="{{distribuidorModulo.agGridConsulta.id}}"
      [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefs" [rowSelection]="rowSelection"
      [rowData]="rowData" (gridReady)="onGridReady($event)" [pagination]="true"
      [paginationPageSize]="distribuidorModulo.agGridConsulta.paginacion">
    </ag-grid-angular>
    <!-- <div style="height: 140px;"> -->
      <div class="col-sm-12">
        <div class="row">
          <div class="col-6">
          </div>
          <div class="col-6">
            <ul class="list-group list-group" style="margin-bottom:0px">
              <li class="list-group-item">
                <b>Total Kilos</b> <a class="pull-right"> {{ reporteModel.totalKilos }}</a>
              </li>
              <li class="list-group-item">
                <b>Total Cajas</b> <a class="pull-right"> {{ reporteModel.totalCantCajas }}</a>
              </li>
              <li class="list-group-item">
                <b>Total Dolares</b> <a class="pull-right">${{ reporteModel.totalImporte }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    <!-- </div> -->
  </div>
</ng-template>
